import React from 'react';
import { SectionSplitter } from '../SideMenuPopover';
import FooterPlatformHub from './FooterPlatformHub.component';
import SwitchModules from './SwitchModules.component';

const PopoverUserProfile: React.FC<React.PropsWithChildren> = () => {
  return (
    <>
      <SwitchModules />
      <SectionSplitter />
      <FooterPlatformHub />
    </>
  );
};

export default PopoverUserProfile;
